import React from 'react';
import {
  Wrapper,
  ArrowLeft,
  Main,
  ColumnLeft,
  ColumnRight,
  Row,
  LeftIcons,
  RightColumnText,
  Link,
  MenuHouse,
  MenuVdp,
  MenuSearch,
  MenuUser,
  MenuExit
} from './sidebar.styles';

const MenuItems = ({ isLoggedIn, vehicleId, location: { search } }) =>
  [
    { icon: <MenuHouse />, href: '/', text: 'Carvana.com' },
    vehicleId > 0 && {
      icon: <MenuVdp />,
      href: `vehicle/${vehicleId}`,
      text: 'Vehicle Details'
    },
    {
      icon: <MenuSearch />,
      href: '/cars',
      text: 'Back to Search Results'
    },
    !isLoggedIn && {
      icon: <MenuUser />,
      href: `/account/signin${search}`,
      text: 'Sign In'
    },
    isLoggedIn && {
      icon: <MenuUser />,
      href: '/account?e=showacctinfo',
      text: 'My Account'
    },
    isLoggedIn && {
      icon: <MenuExit />,
      href: `/account/signout${search}`,
      text: 'Sign Out'
    }
  ].filter(Boolean);

const Sidebar = props => (
  <Wrapper>
    <ArrowLeft />

    <Main>
      <ColumnLeft>
        <LeftIcons>
          {MenuItems(props).map(x => (
            <Row key={x.text}>{x.icon}</Row>
          ))}
        </LeftIcons>
      </ColumnLeft>

      <ColumnRight>
        <RightColumnText>
          {MenuItems(props).map(x => (
            <Row key={x.text}>
              <Link href={x.href}>{x.text}</Link>
            </Row>
          ))}
        </RightColumnText>
      </ColumnRight>
    </Main>
  </Wrapper>
);

export default Sidebar;
